document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('.product__media-list');
  if (!gallery) return;

  gallery.classList.add('carrusel');

  var slides = Array.from(gallery.children);
  if (slides.length <= 1) return;

  var index = 0;
  var startX = 0;
  var currentTranslate = 0;
  var prevTranslate = 0;
  var isDragging = false;
  var animationID = null;
  var slideWidth = gallery.offsetWidth;

  function setSlideWidth() {
    slideWidth = gallery.offsetWidth;
    goTo(index, false);
  }

  function goTo(i, animate = true) {
    if (i < 0) i = 0;
    if (i > slides.length - 1) i = slides.length - 1;
    index = i;
    currentTranslate = -index * slideWidth;
    prevTranslate = currentTranslate;
    gallery.style.transition = animate ? '' : 'none';
    gallery.style.transform = "translateX(" + currentTranslate + "px)";
  }

  function animation() {
    gallery.style.transform = "translateX(" + currentTranslate + "px)";
    if (isDragging) requestAnimationFrame(animation);
  }

  function touchStart(clientX) {
    isDragging = true;
    startX = clientX;
    prevTranslate = currentTranslate;
    gallery.style.transition = 'none';
    animationID = requestAnimationFrame(animation);
  }

  function touchMove(clientX) {
    if (!isDragging) return;
    currentTranslate = prevTranslate + (clientX - startX);
  }

  function touchEnd() {
    if (!isDragging) return;
    isDragging = false;
    cancelAnimationFrame(animationID);
    var movedBy = currentTranslate - prevTranslate;
    if (movedBy < -slideWidth * 0.25 && index < slides.length - 1) index += 1;
    if (movedBy > slideWidth * 0.25 && index > 0) index -= 1;
    goTo(index, true);
  }

  gallery.addEventListener('touchstart', e => touchStart(e.touches[0].clientX), { passive: true });
  gallery.addEventListener('touchmove', e => touchMove(e.touches[0].clientX), { passive: true });
  gallery.addEventListener('touchend', touchEnd);

  gallery.addEventListener('mousedown', e => { e.preventDefault(); touchStart(e.clientX); });
  window.addEventListener('mousemove', e => { if (isDragging) touchMove(e.clientX); });
  window.addEventListener('mouseup', touchEnd);

  window.addEventListener('resize', setSlideWidth);
  setSlideWidth();
  goTo(0, false);
});

